export enum Iso4217CurrencyCode {
    EUR = 'eur',
    SEK = 'sek',
    NOK = 'nok',
    DKK = 'dkk',
    GBP = 'gbp',
    CHF = 'chf',
    USD = 'usd',
    RUB = 'rub',
}
